import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react';

// Redux
import { Provider } from 'react-redux';
import store from './store';

import MainContainer from './MainContainer';
import Layout from './modules/layout/components';
import Dashboard from './modules/dashboard/components';
import Alert from './common/components/Alert';
import ThemeSync from './common/components/ThemeSync';
import Landing from './modules/auth/components';
import Products from './modules/inventory/products/components';
import Stocks from './modules/inventory/stocks/components';
import Promotions from './modules/inventory/promotions/components';
import Suppliers from './modules/inventory/suppliers/components';
import AddNewSupplier from './modules/inventory/suppliers/components/AddNewSupplier';
import Stats from './modules/inventory/stats/components';
import Invoices from './modules/inventory/invoices/components';
import AddNewInvoice from './modules/inventory/invoices/components/AddNewInvoice';
import AddNewProduct from './modules/inventory/products/components/AddNewProduct';
import Categories from './modules/inventory/categories/components';
import AddNewCategory from './modules/inventory/categories/components/AddNewCategory';
import AddNewStock from './modules/inventory/stocks/components/AddNewStock';
import TransferredStocks from './modules/inventory/transferStocks/components';
import TransferStockForm from './modules/inventory/transferStocks/components/TransferStockForm';
import Shipments from './modules/delivery/shipments/components';
import UpdateProduct from './modules/inventory/products/components/UpdateProduct';
import UpdateStock from './modules/inventory/stocks/components/UpdateStock';
import UpdateCategory from './modules/inventory/categories/components/UpdateCategory';
import UpdateSupplier from './modules/inventory/suppliers/components/UpdateSupplier';
import SupplierMerchant from './modules/inventory/supplierReturn/components';
import SupplierReturnDocument from './modules/inventory/supplierReturn/components/ReturnDocument';
import ViewInvoice from './modules/inventory/invoices/components/ViewInvoice';
import Customers from './modules/crm/customers/components';
import MostSoldProducts from './modules/reports/products/components';
import CustomerReports from './modules/reports/customers/components';
import BillHistory from './modules/reports/billHistory/components';
import CategorySalesReports from './modules/reports/category/components';
import SalesReport from './modules/reports/sales/components';
import CashBalanceReport from './modules/reports/cashBalance/components';
import DetailBill from './modules/reports/billHistory/components/DetailBill';
import ReceiptSettings from './modules/settings/receipt/components';
import WarrantySettings from './modules/settings/warranty/components';
import ProductSettings from './modules/settings/product/components';
import LayoutSettings from './modules/settings/layout/components';
import Users from './modules/iam/users/components';
import AddNewUser from './modules/iam/users/components/AddNewUser';
import UpdateUser from './modules/iam/users/components/UpdateUser';
import PaymentsSettings from './modules/settings/payments/components';
import OrderSettings from './modules/settings/order/components';
import ModifierSettings from './modules/settings/modifiers/components';
import Modifiers from './modules/inventory/modifiers/components';
import BusinessDaySettings from './modules/settings/businessDay/components';
import GeneralSettings from './modules/settings/general/components';
import Payment from './modules/payment/components';
import BillView from './modules/billView/components';
import HirePurchaseAgreements from './modules/hirePurchase/agreements/components';

const App = () => {
  return (
    <Provider store={store}>
      <ThemeSync />
      <Alert />
      <BrowserRouter>
        <Routes>
          <Route path="/bill/:encryptedPurchaseData" element={<BillView />} />
          <Route path="/" element={<MainContainer />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="/inventory">
                <Route path="/inventory/products">
                  <Route path="/inventory/products" element={<Products />} />
                  <Route
                    path="/inventory/products/new-product"
                    element={<AddNewProduct />}
                  />
                  <Route
                    path="/inventory/products/update-product/:id"
                    element={<UpdateProduct />}
                  />
                </Route>
                <Route path="/inventory/stocks">
                  <Route path="/inventory/stocks" element={<Stocks />} />
                  <Route
                    path="/inventory/stocks/new-stock"
                    element={<AddNewStock />}
                  />
                  <Route
                    path="/inventory/stocks/update-stock/:id"
                    element={<UpdateStock />}
                  />
                </Route>
                <Route path="/inventory/suppliers" element={<Suppliers />} />
                <Route path="/inventory/invoices">
                  <Route path="/inventory/invoices" element={<Invoices />} />
                  <Route
                    path="/inventory/invoices/new-invoice"
                    element={<AddNewInvoice />}
                  />
                  <Route
                    path="/inventory/invoices/view/:id"
                    element={<ViewInvoice />}
                  />
                </Route>
                <Route path="/inventory/stats" element={<Stats />} />
                <Route path="/inventory/transfer-stocks">
                  <Route path="/inventory/transfer-stocks" element={<TransferredStocks />} />
                  <Route
                    path="/inventory/transfer-stocks/new"
                    element={<TransferStockForm />}
                  />
                </Route>
                <Route path="/inventory/categories">
                  <Route
                    path="/inventory/categories"
                    element={<Categories />}
                  />
                  <Route
                    path="/inventory/categories/new-category"
                    element={<AddNewCategory />}
                  />
                  <Route
                    path="/inventory/categories/update-category/:id"
                    element={<UpdateCategory />}
                  />
                </Route>
                <Route path="/inventory/modifiers" element={<Modifiers />} />
                <Route path="/inventory/suppliers">
                  <Route path="/inventory/suppliers" element={<Suppliers />} />
                  <Route
                    path="/inventory/suppliers/new-supplier"
                    element={<AddNewSupplier />}
                  />
                  <Route
                    path="/inventory/suppliers/update-supplier/:id"
                    element={<UpdateSupplier />}
                  />
                  <Route
                    path="/inventory/suppliers/view/:id"
                    element={<SupplierMerchant />}
                  />
                </Route>
                <Route
                  path="/inventory/supplier-returns/:id"
                  element={<SupplierReturnDocument />}
                />
              </Route>
              {/* CRM routes */}
              <Route path="/crm">
                <Route path="/crm/customers" element={<Customers />} />
              </Route>
              <Route path="/account">
                <Route path="/account/subscription" element={<Payment />} />
              </Route>
              {/* Reports routes */}
              <Route path="/reports">
                <Route path="/reports/products">
                  <Route
                    path="/reports/products"
                    element={<MostSoldProducts />}
                  />
                </Route>
                <Route path="/reports/category">
                  <Route
                    path="/reports/category"
                    element={<CategorySalesReports />}
                  />
                </Route>
                <Route path="/reports/customers">
                  <Route
                    path="/reports/customers"
                    element={<CustomerReports />}
                  />
                </Route>
                <Route path="/reports/bill-history">
                  <Route
                    path="/reports/bill-history"
                    element={<BillHistory />}
                  />
                  <Route
                    path="/reports/bill-history/:billId"
                    element={<DetailBill />}
                  />
                </Route>
                <Route path="/reports/sales" element={<SalesReport />} />
                <Route path="/reports/cash-balance" element={<CashBalanceReport />} />
              </Route>
              {/* Delivery routes */}
              <Route path="/delivery">
                <Route path="/delivery/shipments">
                  <Route path="/delivery/shipments" element={<Shipments />} />
                </Route>
              </Route>
              <Route path="/hire-purchase">
                <Route
                  path="/hire-purchase/agreements"
                  element={<HirePurchaseAgreements />}
                />
              </Route>
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/suppliers" element={<Suppliers />} />
              {/* IAM routes */}
              <Route path="/iam">
                <Route path="/iam/users">
                  <Route path="/iam/users" element={<Users />} />
                  <Route
                    path="/iam/users/new-user"
                    element={<AddNewUser />}
                  />
                  <Route
                    path="/iam/users/update-user/:id"
                    element={<UpdateUser />}
                  />
                </Route>
              </Route>
              {/* Settings routes */}
              <Route path="/settings">
                <Route path="/settings/receipt" element={<ReceiptSettings />} />
                <Route path="/settings/warranty" element={<WarrantySettings />} />
                <Route path="/settings/products" element={<ProductSettings />} />
                <Route path="/settings/layout" element={<LayoutSettings />} />
                <Route path="/settings/payments" element={<PaymentsSettings />} />
                <Route path="/settings/order" element={<OrderSettings />} />
                <Route path="/settings/modifiers" element={<ModifierSettings />} />
                <Route path="/settings/business-day" element={<BusinessDaySettings />} />
                <Route path="/settings/general" element={<GeneralSettings />} />
              </Route>
            </Route>
            <Route path="/login" element={<Landing />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
